import React, { useState, useEffect } from 'react';
import VideoList from './VideoList';
import VideoPlayer from './VideoPlayer';
import './Showcase.css';
import {ImageBackground} from "./ImageBackground";
import {cacheImage} from "../../utils";

const Showcase = (props) => {
  const [videos, setVideos] = useState([]);
  const [currentVideoUri, setCurrentVideoUri] = useState(null);
  const [currentBackground, setCurrentBackground] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    fetch('/showcase')
        .then((res) => res.json())
        .then((response) => {
          /**
           * Don't keep video who required password
           */
          // const filteredVideo = response.data.filter((video) => !video.password);
          cacheImage(response.data);
          setVideos(response && response.data);

        });
  }, []);


  const getCurrent = () =>
      videos.find((video) => video.uri === currentBackground);

  const getCurrentVideo = () => {
    const currentVideo = getCurrent();

    return currentVideo ? currentVideo.files[0] : null;
  };

  const getCurrentImage = () => {
    const currentVideo = getCurrent();

    if (!currentVideo) return null;

    const sizeCount = currentVideo.pictures.sizes.length;
    const pic = currentVideo.pictures.sizes[sizeCount - 1];

    return pic.link;
  };



  return (
      <div className='showcase'>
        {currentVideoUri && !props.isModalOpen? (
            <VideoPlayer
                video={getCurrentVideo()}
                imageUrl={getCurrentImage()}
                onVideoExit={() => {
                  props.onVideoExit();
                  setIsPlaying(false);
                }}
                isPlaying={isPlaying}
                setIsPlaying={setIsPlaying}
            />
        ) : null}

        {currentBackground && !currentVideoUri ? (
            <ImageBackground
                imageUrl={getCurrentImage()}
            />
        ) : null}

        {!props.isFullScreen && !props.isModalOpen && Boolean(videos.length) && (
            <VideoList
                items={videos}
                onItemScroll={(videoUri) => setCurrentBackground(videoUri)}
                onFullScreenClicked={(videoUri) => {
                  setCurrentVideoUri(videoUri)
                  props.onVideoSelected();
                  setIsPlaying(true);
                }}

                onClick={() =>
                    window.scrollTo({
                      left: 0,
                      top: 0,
                      behavior: "smooth",
                    })
                }

                activeVideoUri={currentVideoUri}
            />
        )}
      </div>
  );
};

export default Showcase;